<template>
  <v-app v-if="isReady >= 3 || (!$route.meta.accessRules || !$route.meta.accessRules.accountNeeded)">
    <!-- Attente des actions : posé ici une fois, il couvre tous les écrans. -->
    <BusyIndicator />
    <template v-if="$route.meta.displayNav && profileStore.profile">
      <span v-if="$vuetify.display.mdAndUp">
        <UserNavigation />
        <AdminNavigation v-if="profileStore.profile.role !== 'User'" />
      </span>
      <span v-else>
        <MobileNavigation v-if="profileStore.profile" ref="mobileNavigation" />
      </span>
    </template>
    <v-app-bar height="64" elevation="0" class="d-flex flex-row align-center justify-center" v-if="$route.meta.displayNav && profileStore && profileStore.profile">
      <v-btn color="primary" icon v-if="!$vuetify.display.mdAndUp" @click="$refs.mobileNavigation.toggleMenu()">
        <v-icon size="40">mdi-menu</v-icon>
      </v-btn>
      <Header v-if="$route.meta.displayNav" />
    </v-app-bar>
    <v-main>
      <v-container class="pa-3" style="height: 100%; max-width:100%;">
        <router-view class="router-view" />
      </v-container>
    </v-main>
    <Footer />
  </v-app>
  <v-app v-else>
    <v-main>
      <v-img :src="require('@/assets/images/mfbPoster.png')" cover style="height: 100%; width: 100%; position: absolute; top: 0; left: 0;"></v-img>
      <v-container class="py-0 d-flex flex-column align-center justify-center" style="height: 100%; max-width:100%;" v-if="$vuetify.display.mdAndUp">
        <v-card class="pa-10" style="border-radius: 50px; opacity: .9;">
          <h1 class="text-primary mb-3">Chargement ...</h1>
          <v-progress-circular color="primary" indeterminate :size="200" :width="10">
            <v-img class="mx-2" height="125" width="125" :src="require('@/assets/images/Logo.svg')"></v-img>
          </v-progress-circular>
        </v-card>
      </v-container>
      <v-container class="py-0 d-flex flex-column align-center justify-center" style="height: 100%; max-width:100%;" v-else>
        <v-card class="pa-10" style="border-radius: 50px; opacity: .9;">
          <h3 class="text-primary mb-3">Chargement ...</h3>
          <v-progress-circular color="primary" indeterminate :size="100" :width="6">
            <v-img class="mx-2" height="70" width="70" :src="require('@/assets/images/Logo.svg')"></v-img>
          </v-progress-circular>
        </v-card>
      </v-container>
    </v-main>
    <Footer />
  </v-app>
</template>

<script>
import moment from 'moment'

import packageJSON from '@/../package.json'

import { getAuth } from '@firebase/auth'

import initAppdata from '@/services/firestore/initAppdata'

import { useProfileStore } from '@/stores/profile'
import { useCollectionStore } from '@/stores/collections'
import { useAppStore } from '@/stores/appdata'

import Profile from '@/models/account/Profile'
import Application from '@/models/account/Application'
import Appdata from '@/models/account/Appdata'
import Team from '@/models/catalogue/Team'
import Period from '@/models/catalogue/Period'

import UserNavigation from '@/components/common/UserNavigation.vue'
import AdminNavigation from '@/components/common/AdminNavigation.vue'
import MobileNavigation from '@/components/common/MobileNavigation.vue'
import Footer from '@/components/common/Footer.vue'
import BusyIndicator from '@/components/common/BusyIndicator.vue'
import Header from '@/components/common/Header.vue'
import { rolesOf } from '@/services/roles'
import { mergeDashboardAccess } from '@/services/dashboardAccess'

export default {
  name: 'App',
  components: {
    UserNavigation,
    AdminNavigation,
    MobileNavigation,
    Footer,
    Header,
    BusyIndicator,
  },
  setup() {
    moment.locale('fr')
  },
  data() {
    return {
      profileStore: useProfileStore(),
      collections: useCollectionStore(),
      appStore: useAppStore(),
      packageJSON,
      unsub: [],
      nesteadUnsub: [],
      nestead2Unsub: [],
      mobileMenu: false,
      isReady: 0,
      isOnGoodVersion: false,
      loaded: {
        teams: false,
        periods: false
      }
    }
  },
  async mounted() {
    getAuth().onAuthStateChanged(async user => {
      if (user) {
        this.unsub.push(await Profile.listenById(user.uid, async profile => {
          if (profile && profile.currentApps != undefined && profile.currentApps.app_myFirstBusiness != undefined) {
            this.profileStore.profile = profile
            if (profile.role !== 'SuperAdmin') {
              this.profileStore.profile.role = profile.organisations[profile.currentOrganisation].role
            }
            this.isReady++

            for (const unsub of this.nesteadUnsub) {
              if (typeof unsub === 'function') {
                unsub()
              }
            }
            this.nesteadUnsub.push(await Appdata.listenByApplication(profile.currentApps.app_myFirstBusiness, async appdata => {
              this.appStore.appdata = appdata
              if (!this.appStore.appdata.parameters) {
                // console.time('Appdata successfully save')
                this.appStore.appdata = initAppdata(this.appStore.appdata)
                await this.appStore.appdata.save()
                // console.timeLog('Appdata successfully save')
              }
              if(!this.appStore.appdata.parameters.version){
                this.appStore.appdata.parameters.version = parseInt(packageJSON.version.split('.')[0])
                await this.appStore.appdata.save()
              }
              if(this.appStore.appdata.parameters.version < parseInt(packageJSON.version.split('.')[0])){
                this.isOnGoodVersion = false
              }else{
                this.isOnGoodVersion = true
              }

              if(!this.isOnGoodVersion){
                this.$router.push('/BadVersion')
              }

              this.isReady++
            }))
            this.nesteadUnsub.push(await Application.listenById(profile.currentApps.app_myFirstBusiness, async application => {
              this.appStore.app = application
              if (this.appStore.app) {
                if (this.appStore.app.archived) {
                  this.$router.push('/NoCurrentApp')
                } else {
                  for (const unsub of this.nestead2Unsub) {
                    if (typeof unsub === 'function') {
                      unsub()
                    }
                  }

                  // PERIODS
                  this.nestead2Unsub.push(await Period.listenAll(async res => {
                    if (res.length === 0) {
                      const new_period = Period.initOne()
                      await new_period.save()
                    }else{
                      res = res.sort((a, b) => {
                        if (a.year == b.year){
                          return a.month - b.month
                        }else{
                          return a.year - b.year
                        }
                      })
                      // await res[0].save()
                    }
                    
                    let availablePeriods = res

                    this.collections.allPeriods = availablePeriods

                    if (this.profileStore.profile.role === 'User') {
                      availablePeriods = availablePeriods.filter(period => period.strategyAvailable)
                    }

                    this.collections.periods = availablePeriods

                    if(!this.profileStore.selectedPeriod){
                      this.profileStore.selectedPeriod = this.collections.periods[this.collections.periods.length -1]
                    }else if(this.collections.periods.find(period => period.id === this.profileStore.selectedPeriod.id) == null){
                      this.profileStore.selectedPeriod = this.collections.periods[this.collections.periods.length -1]
                    }else{
                      this.profileStore.selectedPeriod = this.collections.periods.find(period => period.id === this.profileStore.selectedPeriod.id)
                    }

                    this.loaded.periods = true
                    this.collections.loaded = this.loaded.periods && this.loaded.teams
                  }))

                  // TEAMS
                  this.nestead2Unsub.push(await Team.listenAll(res => {
                    this.collections.teams = res.sort((a, b) => a.name.localeCompare(b.name))

                    if (this.profileStore.profile.role === 'User') {
                      const currentTeam = res.find(team => team.users.includes(this.profileStore.profile.id))
                      this.profileStore.team = currentTeam
                      this.profileStore.selectedTeam = currentTeam

                    } else {
                      if (!this.profileStore.selectedTeam) {
                        this.profileStore.selectedTeam = this.collections.teams[0]
                      }else{
                        this.profileStore.selectedTeam = this.collections.teams.find(team => team.id === this.profileStore.selectedTeam.id)
                      }
                    }
                    if (this.profileStore.profile.role === 'User' && !this.profileStore.team){
                      this.$router.push('/NoCurrentTeam')
                    }

                    this.loaded.teams = true
                    this.collections.loaded = this.loaded.periods && this.loaded.teams
                  }))
                }
              }
              this.isReady++
            }))

          }else{
            if(!profile){
              this.logout()
            }
            else if(profile.currentApps == undefined || profile.currentApps.app_myFirstBusiness == undefined){
              this.$router.push('/NoCurrentApp')
            }else{
              this.logout()
            }
          }
        }))
      }
      else this.logout()
    })
  },
  watch: {
    'profileStore.profile': {
      handler: function() {
        if (this.profileStore.profile) {
          this.updateRolesAccess()
        }
      },
      deep: true
    },
    'profileStore.team': {
      handler: function() {
        if (this.profileStore.team) {
          this.updateRolesAccess()
        }
      },
      deep: true
    },
    'appStore.appdata': {
      handler: function() {
        if (this.appStore.appdata) {
          this.updateRolesAccess()
        }
      },
      deep: true
    }
  },
  methods: {
    updateRolesAccess(){
      /*
        Trois veilleurs appellent cette méthode — profil, équipe et appdata — et le premier
        à répondre déclenche le calcul alors que les autres données peuvent manquer encore.
        Le profil arrive avant l'appdata : la lecture des rôles levait alors
        « Cannot read properties of null (reading 'parameters') », ce qui interrompait le
        rappel du veilleur. Le calcul est simplement reporté : le veilleur sur `appStore.appdata`
        le relancera dès que les paramètres seront là.
      */
      const parameters = this.appStore.appdata ? this.appStore.appdata.parameters : null
      if (!this.profileStore.profile || !parameters) return

      let tmp_accessPages = {}
      let tmp_editPages = {}
      let tmp_accessDashboard = {}
      const dashboardRights = []

      let currentTeam = this.profileStore.team

      // Le rôle par défaut n'est pas inscrit dans l'équipe : il est ajouté à la lecture.
      const currentRoleNames = rolesOf(currentTeam, this.profileStore.profile.id, parameters.roles)

      if(currentRoleNames.length > 0){
        for(let roleId of currentRoleNames){
          if(parameters.roles.find(role => role.name === roleId)){
            const role = parameters.roles.find(role => role.name === roleId)
            for(let page in role.accessPages){
              if(tmp_accessPages[page] == undefined){
                tmp_accessPages[page] = false
              }
              tmp_accessPages[page] = tmp_accessPages[page] || role.accessPages[page]
            }
            for(let page in role.editPages){
              if(tmp_editPages[page] == undefined){
                tmp_editPages[page] = false
              }
              tmp_editPages[page] = tmp_editPages[page] || role.editPages[page]
            }
            // Les droits du tableau de bord sont réunis à part : ils demandent une
            // conversion des anciennes clés de disposition vers les blocs actuels.
            dashboardRights.push(role.accessDashboard)
          }
        }
      }

      tmp_accessDashboard = { enabled: mergeDashboardAccess(dashboardRights) }

      this.profileStore.accessPages = tmp_accessPages
      this.profileStore.editPages = tmp_editPages
      this.profileStore.accessDashboard = tmp_accessDashboard
    },
    logout() {
      this.isReady = 0
      this.profileStore.profile = null
      this.profileStore.team = null
      this.appStore.appId = null
      if (!this.$route.meta.accessRules || (this.$route.meta.accessRules && this.$route.meta.accessRules.accountNeeded)) {
        this.$router.push('/login')
      }
    }
  },
  destroyed() {
    this.unsub.forEach(unsub => {
      if (typeof unsub === 'function') unsub()
    })
    this.nesteadUnsub.forEach(unsub => {
      if (typeof unsub === 'function') unsub()
    })
    this.nestead2Unsub.forEach(unsub => {
      if (typeof unsub === 'function') unsub()
    })
  },
}
</script>

<style>
.router-view {
  max-height: calc(100vh - 130px);
}
</style>
